import { OrganisationTreeDto } from '@/api';

export const flatOrganisations = (childOrgs: OrganisationTreeDto[]) => {
  let result: OrganisationTreeDto[] = [];

  childOrgs.forEach((a) => {
    result.push(a);
    if (Array.isArray(a.children)) {
      result = [...result, ...flatOrganisations(a.children)];
    }
  });

  return result;
};
